import axios from 'axios';

export class CouponsService {
    async fetchAll() {
        return (await axios.get('/stripe/coupons')).data.filter((o) => o.active);
    }

    async create(coupon) {
        return (await axios.post('/stripe/create-coupon', coupon)).data;
    }

    async delete(coupon) {
        return (await axios.delete('/stripe/delete-coupon/' + coupon.coupon.id)).data;
    }
}
